import { useFeed } from "@/hooks/queries/use-social";
import type { FeedEventEntry } from "types/web-app";

const formatEvent = (event: FeedEventEntry): string => {
  const payload = event.payload as Record<string, unknown>;
  switch (event.type) {
    case "SHINY_PACK_REVEAL":
      return `✨ ${event.username} opened a shiny ${payload.base_pokemon_name}!`;
    case "FULL_ART_PACK_REVEAL":
      return `🎨 ${event.username} pulled a full-art ${payload.base_pokemon_name}!`;
    case "AUCTION_LOT_SOLD":
      return `🏆 ${event.username} won the auction for ${payload.pack_definition_key} at ${payload.final_price} coins`;
    case "SIEGE_PERSONAL_BEST":
      return `🗺️ ${event.username} cleared a new Siege record — Tier ${payload.tier}!`;
    default:
      return "";
  }
};

const timeAgo = (iso: string): string => {
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  return `${Math.floor(diff / 3600)}h ago`;
};

export const HomeFeedTicker = () => {
  const { data } = useFeed();
  const events = data?.events ?? [];

  if (events.length === 0) return null;

  return (
    <div className="w-full max-w-sm px-3 py-1.5 bg-pk-night-1/50 rounded overflow-hidden">
      <div className="flex flex-col gap-0.5">
        {events.slice(0, 3).map((event) => {
          const text = formatEvent(event);
          if (!text) return null;
          return (
            <div key={event.id} className="flex items-center justify-between gap-1.5 min-w-0">
              <span className="text-pk-gray-4 text-[10px] leading-tight truncate flex-1">
                {text}
              </span>
              <span className="text-pk-gray-4/60 text-[9px] shrink-0">
                {timeAgo(event.created_at)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
